import ArchiveFileIcon from '../components/icons/files/archiveFile';
import AudioFileIcon from '../components/icons/files/audioFile';
import DocFileIcon from '../components/icons/files/docFile';
import GenericFileIcon from '../components/icons/files/genericFile';
import ImageFileIcon from '../components/icons/files/imageFile';
import PdfFileIcon from '../components/icons/files/pdfFile';
import SheetFileIcon from '../components/icons/files/sheetFile';
import SlideFileIcon from '../components/icons/files/slideFile';
import VideoFileIcon from '../components/icons/files/videoFile';
const EXT_MAP = {
    pdf: PdfFileIcon,
    doc: DocFileIcon,
    docx: DocFileIcon,
    rtf: DocFileIcon,
    odt: DocFileIcon,
    txt: DocFileIcon,
    md: DocFileIcon,
    xls: SheetFileIcon,
    xlsx: SheetFileIcon,
    csv: SheetFileIcon,
    ods: SheetFileIcon,
    ppt: SlideFileIcon,
    pptx: SlideFileIcon,
    odp: SlideFileIcon,
    key: SlideFileIcon,
    zip: ArchiveFileIcon,
    rar: ArchiveFileIcon,
    '7z': ArchiveFileIcon,
    tar: ArchiveFileIcon,
    gz: ArchiveFileIcon,
    jpg: ImageFileIcon,
    jpeg: ImageFileIcon,
    png: ImageFileIcon,
    gif: ImageFileIcon,
    webp: ImageFileIcon,
    bmp: ImageFileIcon,
    svg: ImageFileIcon,
    heic: ImageFileIcon,
    mp4: VideoFileIcon,
    mov: VideoFileIcon,
    avi: VideoFileIcon,
    mkv: VideoFileIcon,
    webm: VideoFileIcon,
    mp3: AudioFileIcon,
    wav: AudioFileIcon,
    ogg: AudioFileIcon,
    m4a: AudioFileIcon,
    aac: AudioFileIcon,
};
const extractExt = (name) => {
    if (!name)
        return '';
    const dot = name.lastIndexOf('.');
    if (dot < 0 || dot === name.length - 1)
        return '';
    return name.slice(dot + 1).toLowerCase();
};
export const getFileIconByName = (name, contentType) => {
    const ext = extractExt(name);
    if (ext && EXT_MAP[ext])
        return EXT_MAP[ext];
    if (contentType) {
        if (contentType.startsWith('image/'))
            return ImageFileIcon;
        if (contentType.startsWith('video/'))
            return VideoFileIcon;
        if (contentType.startsWith('audio/'))
            return AudioFileIcon;
        if (contentType === 'application/pdf')
            return PdfFileIcon;
        if (contentType.includes('spreadsheet') || contentType === 'text/csv')
            return SheetFileIcon;
        if (contentType.includes('presentation'))
            return SlideFileIcon;
        if (contentType.includes('word') ||
            contentType === 'text/plain' ||
            contentType === 'application/rtf') {
            return DocFileIcon;
        }
        if (contentType.includes('zip') || contentType.includes('compressed'))
            return ArchiveFileIcon;
    }
    return GenericFileIcon;
};
